<mat-drawer-container style="height: 100%">
  <mat-drawer-content style="background: white">
    <h3>アラート</h3>
    <div class="left-pane">
      <div fxLayout="column">
        <div fxLayout="row">
          <span class="label">対象日:</span>
          <span>{{alert.date}}</span>
        </div>
        <div fxLayout="row">
          <span class="label">登録日時:</span>
          <span>{{alert.timeStamp.toDate() | timestamp: 'yyyy-MM-dd hh:mm:ss'}}</span>
        </div>
        <div fxLayout="row">
          <span class="label">対象ロット:</span>
          <span>{{commonService.getName(masterService.keishaMaster, alert.keishaId, 'farmKeisha')}}
            <div *ngIf="alert.shiyoulotName">{{alert.shiyoulotName}}</div>
          </span>
        </div>
        <div fxLayout="row">
          <span class="label">内容:</span>
<!--          <span *ngIf="alert.alertContents">{{alert.alertContents}}</span>-->
          <span>{{alert.alertAbstract}}</span>
        </div>
        <div fxLayout="row">
          <span class="label">担当者:</span>
          <span>{{alert?.operator}}</span>
        </div>
      </div>
    </div>
  </mat-drawer-content>
  <mat-drawer style="width: 50%"opened position="end" mode="side">
    <div class="right-pane">
      <form #jisshiForm="ngForm">
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field appearance="legacy" style="padding-bottom: 10px">
            <mat-label>確認日</mat-label>
            <input matInput [matDatepicker]="kakuninDatePicker" disabled
                   [(ngModel)]="alert.kakuninDate" name="kakuninDate">
            <mat-datepicker-toggle matSuffix [for]="kakuninDatePicker"></mat-datepicker-toggle>
            <mat-datepicker touchUi #kakuninDatePicker disabled="true"></mat-datepicker>
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field style="width: 201px">
            <mat-label>
              確認者
            </mat-label>
            <input matInput placeholder="確認者" required
                   name="kakuninOperator" [(ngModel)]="alert.kakuninOperator">
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field style="width: 80%">
            <mat-label>
              コメント
            </mat-label>
            <textarea matInput name="bikou" [(ngModel)]="alert.kakuninComment" rows="7"></textarea>
          </mat-form-field>
        </div>
        <button mat-raised-button color="primary" [disabled]="jisshiForm.invalid"
                (click)="register()" style="margin-right: 12px;margin-bottom: 12px">登録
        </button>
      </form>
    </div>
  </mat-drawer>
</mat-drawer-container>
